import React, { useState, useEffect, useMemo, useRef, useCallback, startTransition } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { IAProfBanner } from '../../components/IAProfBanner'
import {
    clssInfo,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getVthQuarter,
    getVIthQuarter,
    closeBimesterDiary,
    CreateDialy,
    CreateRepoCard,
    CreateDailyConcept,
    CreateRepoCardConcept,
    getSchoolYear,
    getAssessmentRegime,
    RefreshAnnualForms
} from '../../Api'

import {
    Container,
    ContainerDivs,
    ClassDetails,
    ClassSerie,
    ClassInfo,
    ButtonContainer,
    DiaryWrapper,
    DiaryBimester,
    StatusLine,
    StatusBadge,
    DeadlineWarning,
    SeeDiaryButton,
    FinalResultBlock,
    StudentSection,
    StudentActions,
    LinkAction,
    CountRow,
    CountChip,
    TransferHeading,
    StudentItem,
    StudentStatus,
    InfoText,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold,
    ContainerModal,
    ModalContent,
    Input,
    Label,
    Select,
    ModalBackground,
    ModalContainer,
    ModalButton,
    ModalActions,
    ModalConfirm,
    ModalCancel,
    ModalWarnText,
} from './style';
import LoadingSpinner from '../../components/Loading'

import { FcInspection, FcAddressBook } from "react-icons/fc";
import { FaListUl } from "react-icons/fa6";
import { BsListCheck } from "react-icons/bs";
import { FaUserGraduate } from 'react-icons/fa'
import { TbChecklist } from "react-icons/tb";

import ClassPerformanceChart from '../../components/ClassPerformanceChart'

const MyCla$$Info = () => {

    const navigate = useNavigate()

    const [/*year*/, setyear] = useState('');
    const [assessmentFormat, setassessmentFormat] = useState('');
    const [assessmentRegime, setAssessmentRegime] = useState('');
    const [clss, setClss] = useState([])
    const [DailyClass, setDailyClass] = useState([])
    const [stdt, setStdt] = useState([])
    const [studentTransferMap, setstudentTransferMap] = useState([]);

    const [classRegentEmployee, setclassRegentEmployee] = useState([])

    const [nameSchool, setnameSchool] = useState([])

    const [AllBimBull, setBimAllBull] = useState(false);

    const [bimonthly, setBimonthly] = useState([]);

    const [idTeacher, setId_teacher] = useState('')
    const [RegentTeacher, setclassRegentTeacher] = useState([]);
    const [RegentTeacher02, setclassRegentTeacher02] = useState([]);
    const [physicalEducation, setphysicalEducationTeacher] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [selectedBimester, setSelectedBimester] = useState(null);
    const [selectedField, setSelectedField] = useState(null);

    const [showRegentWarning, setShowRegentWarning] = useState(false);

    const [yearclss, setyearclss] = useState('')

    const { id_class } = useParams();
    const { id_teacher } = useParams();

    const [loading, setLoading] = useState(true);
    const [quartersLoaded, setQuartersLoaded] = useState(false);
    const quartersFetching = useRef(false);
    const quartersLoadedRef = useRef(false);

    const loadQuarters = useCallback(async (yearOfClass, idSchool) => {
        if (quartersFetching.current || quartersLoadedRef.current) return;
        if (!yearOfClass || idSchool == null) return;
        quartersFetching.current = true;
        try {
            const [
                IstQuarter, IIndQuarter, IIIrdQuarter,
                IVthQuarter, VthQuarter, VIthQuarter
            ] = await Promise.all([
                getIstQuarter(yearOfClass, idSchool),
                getIIndQuarter(yearOfClass, idSchool),
                getIIIrdQuarter(yearOfClass, idSchool),
                getIVthQuarter(yearOfClass, idSchool),
                getVthQuarter(yearOfClass, idSchool),
                getVIthQuarter(yearOfClass, idSchool)
            ]);

            const i = IstQuarter.data.data.find(res => res) || null;
            const ii = IIndQuarter.data.data.find(res => res) || null;
            const iii = IIIrdQuarter.data.data.find(res => res) || null;
            const iv = IVthQuarter.data.data.find(res => res) || null;
            const v = VthQuarter.data.data.find(res => res) || null;
            const vi = VIthQuarter.data.data.find(res => res) || null;

            setBimonthly([i, ii, iii, iv, v, vi].filter(res => res !== null));
            quartersLoadedRef.current = true;
            setQuartersLoaded(true);
        } catch (err) {
            console.error("Erro ao carregar bimestres:", err);
        } finally {
            quartersFetching.current = false;
        }
    }, []);

    const quarterCtx = useRef({ year: null, idSchool: null });

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);

            const idSchoolRaw = sessionStorage.getItem("id-school");
            const idSchool = JSON.parse(idSchoolRaw);

            const [schoolYear, regimeResp, resClass] = await Promise.all([
                getSchoolYear(idSchool),
                getAssessmentRegime(idSchool),
                clssInfo(id_class)
            ]);

            if (cancelled) return;

            setyear(schoolYear.data.data);
            setnameSchool(sessionStorage.getItem('School'));
            setassessmentFormat(sessionStorage.getItem('assessmentFormat'));

            if (regimeResp?.data?.data) {
                setAssessmentRegime(regimeResp.data.data);
                sessionStorage.setItem('assessmentRegime', regimeResp.data.data);
            }

            sessionStorage.removeItem("Selectbimonthly");
            sessionStorage.removeItem("Selectmatt");
            sessionStorage.removeItem("attendance_ idmatter");
            sessionStorage.removeItem("selectedDate");
            sessionStorage.removeItem("day");
            sessionStorage.removeItem("month");
            sessionStorage.removeItem("year");

            const classData = resClass.data.data;
            const first = classData.find(res => res);

            setDailyClass(first.dailyStatus);
            setClss(classData);

            const transferStdtMap = first.transferStudents;
            setstudentTransferMap(transferStdtMap);

            const regent = first.classRegentTeacher.map(r => r).find(r => r) || null;
            if (regent) {
                sessionStorage.setItem("classRegentTeacher", JSON.stringify(regent._id));
                setclassRegentTeacher(regent._id);
            }
            setclassRegentEmployee(prev => prev);

            const regent02 = first.classRegentTeacher02.map(r => r).find(r => r) || null;
            if (regent02) {
                sessionStorage.setItem("classRegentTeacher02", JSON.stringify(regent02._id));
                setclassRegentTeacher02(regent02._id);
            }

            const pe = first.physicalEducationTeacher.map(r => r).find(r => r) || null;
            if (pe) {
                sessionStorage.setItem("physicalEducationTeacher", JSON.stringify(pe._id));
                setphysicalEducationTeacher(pe._id);
            }

            const loggedTeacher = JSON.parse(localStorage.getItem("Id_employee") || '""');
            setId_teacher(loggedTeacher);

            const $yearClass = classData.find(c => c.year);
            setyearclss($yearClass);

            setLoading(false);

            const student = first.id_student.map(res => (res ? res : null));
            startTransition(() => {
                setStdt(student);
            });

            quarterCtx.current = { year: $yearClass?.year, idSchool };
            if ($yearClass?.year) {
                setTimeout(() => {
                    if (!cancelled) loadQuarters($yearClass.year, idSchool);
                }, 0);
            }
        })();

        return () => { cancelled = true; };
    }, [id_class, id_teacher, loadQuarters]);

    const StudentInformation = async (stdt) => {
        setLoading(true);
        navigate(`/student/info/${stdt._id}`)
        setLoading(false);
    }

    const normalizeString = (str) => {
        return str
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, "")
            .toUpperCase();
    };

    const sortedStudents = useMemo(() => {
        return [...stdt].sort((a, b) =>
            normalizeString(a.name).localeCompare(normalizeString(b.name))
        );
    }, [stdt]);

    const messageButtonClick = () => {
        navigate(-1);
    };

    const getRandomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const bgColor = useMemo(() => {
        let storedColor = sessionStorage.getItem("backgroundColor");
        if (!storedColor) {
            const color1 = getRandomColor();
            const color2 = getRandomColor();
            const angle = Math.floor(Math.random() * 360);
            storedColor = `linear-gradient(${angle}deg, ${color1}, ${color2})`;
            sessionStorage.setItem("backgroundColor", storedColor);
        }
        return storedColor;
    }, []);

    const getTextColor = (bgColor) => {
        if (!bgColor) return "#FFF";
        const regex = /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/i;
        const matches = bgColor.match(regex);
        if (!matches) return "#FFF";
        const r = parseInt(matches[1], 16);
        const g = parseInt(matches[2], 16);
        const b = parseInt(matches[3], 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? "#000" : "#FFF";
    };

    const textColor = useMemo(() => getTextColor(bgColor), [bgColor]);

    const PrintableAttendanceSheet = async () => {
        setLoading(true);
        const serie = clss.map(clss => clss.serie)
        navigate('/printable-attendance-sheet', {
            state: {
                students: sortedStudents,
                schoolName: nameSchool,
                className: serie,
                teacherName: classRegentEmployee
            }
        });
        setLoading(false);
    }

    const PrintableAllTheBulletinsGrades = async () => {
        if (!quartersLoaded) {
            const { year: y, idSchool } = quarterCtx.current;
            loadQuarters(y, idSchool);
        }
        setBimAllBull(true)
    }

    const handleBimonthlyChange = (e) => {
        const value = e.target.value;

        if (value === "FinalConcepts") {
            if (assessmentFormat === 'grade') {
                navigate(`/allTheFinalBulletins-grades/${id_class}`)
            }
            if (assessmentFormat === 'concept') {
                navigate(`/allTheFinalBulletins-concept/${id_class}`)
            }
            return;
        }

        const selectedBimonthly = JSON.parse(value);
        const idBim = selectedBimonthly._id

        if (assessmentFormat === 'grade') {
            if (selectedBimonthly.bimonthly === "1º BIMESTRE") {
                navigate(`/Ist-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "2º BIMESTRE") {
                navigate(`/IInd-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "3º BIMESTRE") {
                navigate(`/IIIrd-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "4º BIMESTRE") {
                navigate(`/IVth-allTheBulletins-grades/${id_class}/${idBim}`)
            }
        }

        if (assessmentFormat === 'concept') {
            if (selectedBimonthly.bimonthly === "1º BIMESTRE") {
                navigate(`/Ist-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "2º BIMESTRE") {
                navigate(`/IInd-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "3º BIMESTRE") {
                navigate(`/IIIrd-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "4º BIMESTRE") {
                navigate(`/IVth-allTheBulletins-concept/${id_class}/${idBim}`)
            }
        }
    };

    const confirmCloseDiary = (bimester, field) => {
        setSelectedBimester(bimester);
        setSelectedField(field);
        setShowModal(true);
    };

    const handleClose = async (bimester, field) => {
        setLoading(true);

        const Bimester = bimonthly.find(item => item.bimonthly === bimester);

        if (assessmentFormat === 'grade') {
            if (bimester === "1º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "2º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "3º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "4º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
        }

        if (assessmentFormat === 'concept') {
            if (bimester === "1º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "2º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "3º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "4º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
        }
    };

    const seeDiary = async (bimester) => {
        const Bimester = bimonthly.find(item => item.bimonthly === bimester);
        navigate(`/bimonthly-diary/${bimester}/${id_class}/${Bimester._id}`)
    }

    // diário ainda aberto: prévia com tudo o que já está gravado (marcada como PRÉVIA)
    const seePreview = (bimester) => {
        const Bimester = bimonthly.find(item => item.bimonthly === bimester);
        if (!Bimester) return;
        navigate(`/bimonthly-diary/${bimester}/${id_class}/${Bimester._id}?previa=1`)
    }

    const clickAttendance = () => {
        navigate('/AllAttendances')
    }

    const getDiaryLabel = (rawBimester) => {
        if (assessmentRegime === 'TRIMESTRAL') {
            return rawBimester.replace('BIMESTRE', 'TRIMESTRE')
        }
        return rawBimester
    }

    // resolve a data-limite (prazo) do período a partir do objeto do bimestre/trimestre.
    // o prazo final vem em três campos string: endday, endmonth, endyear.
    const getPeriodDeadline = (rawBimester) => {
        const Bimester = bimonthly.find(item => item.bimonthly === rawBimester);
        if (!Bimester) return null;

        const day = parseInt(Bimester.endday, 10);
        const month = parseInt(Bimester.endmonth, 10);
        const year = parseInt(Bimester.endyear, 10);

        if (
            Number.isNaN(day) ||
            Number.isNaN(month) ||
            Number.isNaN(year)
        ) {
            return null;
        }

        // month é 1-based no banco; Date usa 0-based
        const date = new Date(year, month - 1, day);
        return isNaN(date.getTime()) ? null : date;
    };

    // verdadeiro quando o prazo do período já passou (comparando só a data, sem horário)
    const isPeriodOverdue = (rawBimester) => {
        const deadline = getPeriodDeadline(rawBimester);
        if (!deadline) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);
        return deadline < today;
    };

    const formatDeadline = (date) => {
        try {
            return date.toLocaleDateString('pt-BR');
        } catch {
            return '';
        }
    };
    const finalPeriodKey = assessmentRegime === 'TRIMESTRAL'
        ? '3º BIMESTRE'
        : '4º BIMESTRE';

    const finalPeriodStatus = DailyClass?.[finalPeriodKey];
    const idLoggedTeacher = id_teacher;

    const isRegent =
        idLoggedTeacher === RegentTeacher ||
        idLoggedTeacher === RegentTeacher02;

    const isPhysical =
        idLoggedTeacher === physicalEducation;

    const isFinalClosed = isRegent
        ? finalPeriodStatus?.regentTeacher === "fechado"
        : isPhysical
            ? finalPeriodStatus?.physicalEducationTeacher === "fechado"
            : false;

    const goToFinalResult = () => {
        navigate(`/final-diary/${id_class}/${yearclss.year}`);
    };

    return (
        <Container>
            {loading ?
                <LoadingSpinner />
                :
                <ContainerDivs>
                    {clss.map((clss) => (
                        <ClassDetails
                            key={clss._id}
                            style={{ background: bgColor, color: textColor }}
                        >
                            <ClassSerie style={{ color: textColor }}>{clss.serie}</ClassSerie>
                            <ClassInfo style={{ color: textColor }}>{clss.name}</ClassInfo>
                            <ClassInfo style={{ color: textColor }}>Turno: {clss.shift}</ClassInfo>
                        </ClassDetails>
                    ))}

                    {/* ⬇️ GRÁFICO DE DESEMPENHO — antes dos botões de funções principais */}
                    <ClassPerformanceChart
                        idClass={id_class}
                        year={yearclss?.year}
                        assessmentFormat={assessmentFormat}
                    />

                    {/* anúncio do I.A Prof (acima dos botões) */}
                    <IAProfBanner />

                    <ButtonContainer>
                        <button onClick={clickAttendance}>
                            <FcInspection />
                            Frequências
                        </button>
                        <button onClick={() => { navigate('/classes') }}>
                            <FcAddressBook />
                            Aulas
                        </button>
                        {assessmentFormat === 'grade' && (
                            <button className="span-mobile" onClick={() => { navigate('/$activities') }}>
                                <TbChecklist color="orange" />
                                Avaliações
                            </button>
                        )}
                        {assessmentFormat === 'grade' && (
                            <button className="span-mobile" onClick={() => { navigate(`/recovery/${id_class}`) }}>
                                <span style={{ fontSize: 26 }} aria-hidden>🔁</span>
                                Recuperação
                            </button>
                        )}
                        {assessmentFormat === 'concept' && (
                            <button className="span-mobile" onClick={() => { navigate('/$concepts') }}>
                                <FaListUl color="orange" />
                                Conceitos
                            </button>
                        )}
                    </ButtonContainer>

                    {assessmentFormat === 'concept' &&
                        <ButtonContainer>
                            <button onClick={() => { navigate('/individual-report') }}>
                                <FaUserGraduate />
                                Relatório Individual
                            </button>
                            <button onClick={() => { navigate('/$finalConcepts') }}>
                                <BsListCheck color="#2ECC71" />
                                Conceitos Finais
                            </button>
                        </ButtonContainer>
                    }

                    <div style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 10px' }}>
                        <button
                            type="button"
                            onClick={() => navigate(`/class-schedule/${id_class}?ver=1`)}
                            style={{ padding: '8px 16px', borderRadius: 999, border: '1px solid #2563eb', background: '#e8f0fe', color: '#1d4ed8', fontWeight: 700, cursor: 'pointer' }}
                        >
                            🕒 Ver horário da turma
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(`/occurrences/class/${id_class}`)}
                            style={{ padding: '8px 16px', borderRadius: 999, border: '1px solid #d97706', background: '#fff4e5', color: '#b45309', fontWeight: 700, cursor: 'pointer', marginLeft: 8 }}
                        >
                            📝 Ocorrências
                        </button>
                    </div>

                    <DiaryWrapper>
                        <h2>📓 Diário da Turma</h2>
                        {Object.entries(DailyClass)
                            .filter(([rawBimester]) => {
                                if (assessmentRegime === 'TRIMESTRAL') {
                                    return !rawBimester.includes('4º')
                                }
                                return true
                            })
                            .map(([rawBimester, status], index) => {
                                const isRegentView =
                                    RegentTeacher === idTeacher || RegentTeacher02 === idTeacher;
                                const isPhysicalView = physicalEducation === idTeacher;

                                const regentOpen =
                                    isRegentView && status.regentTeacher === 'aberto';
                                const physicalOpen =
                                    isPhysicalView && status.physicalEducationTeacher === 'aberto';

                                const showOverdueWarning =
                                    (regentOpen || physicalOpen) && isPeriodOverdue(rawBimester);

                                const deadlineDate = getPeriodDeadline(rawBimester);

                                return (
                                <DiaryBimester key={index}>
                                    <h3>{getDiaryLabel(rawBimester)}</h3>

                                    {showOverdueWarning && (
                                        <DeadlineWarning>
                                            <span role="img" aria-label="alerta">⚠️</span>
                                            <span>
                                                O prazo deste período
                                                {deadlineDate ? ` encerrou em ${formatDeadline(deadlineDate)}` : ' já foi encerrado'} e o
                                                diário continua aberto. Lance todos os dados pendentes e feche o diário
                                                para consolidar as informações dos alunos.
                                            </span>
                                        </DeadlineWarning>
                                    )}

                                    <StatusLine>
                                        {(RegentTeacher === idTeacher || RegentTeacher02 === idTeacher) &&
                                            status.regentTeacher === 'aberto' && (
                                                <>
                                                    <strong>
                                                        Professor Regente
                                                        <StatusBadge $open>● Aberto</StatusBadge>
                                                    </strong>
                                                    <SeeDiaryButton title="Diário ainda aberto: mostra o que já está gravado (prévia)" style={{ background: '#fff4e5', color: '#b45309', border: '1px dashed #b45309' }} onClick={() => seePreview(rawBimester)}>
                                                        Ver prévia
                                                    </SeeDiaryButton>
                                                    <button onClick={() => confirmCloseDiary(rawBimester, 'regentTeacher')}>
                                                        Fechar
                                                    </button>
                                                </>
                                            )
                                        }

                                        {(RegentTeacher === idTeacher || RegentTeacher02 === idTeacher) &&
                                            status.regentTeacher === 'fechado' && (
                                                <>
                                                    <strong>
                                                        Professor Regente
                                                        <StatusBadge>✓ Fechado</StatusBadge>
                                                    </strong>
                                                    <SeeDiaryButton onClick={() => seeDiary(rawBimester)}>
                                                        Ver Diário
                                                    </SeeDiaryButton>
                                                </>
                                            )
                                        }

                                        {physicalEducation === idTeacher &&
                                            status.physicalEducationTeacher === 'aberto' && (
                                                <>
                                                    <strong>
                                                        Ed. Física
                                                        <StatusBadge $open>● Aberto</StatusBadge>
                                                    </strong>
                                                    <SeeDiaryButton title="Diário ainda aberto: mostra o que já está gravado (prévia)" style={{ background: '#fff4e5', color: '#b45309', border: '1px dashed #b45309' }} onClick={() => seePreview(rawBimester)}>
                                                        Ver prévia
                                                    </SeeDiaryButton>
                                                    <button onClick={() => confirmCloseDiary(rawBimester, 'physicalEducationTeacher')}>
                                                        Fechar
                                                    </button>
                                                </>
                                            )
                                        }

                                        {physicalEducation === idTeacher &&
                                            status.physicalEducationTeacher === 'fechado' && (
                                                <>
                                                    <strong>
                                                        Ed. Física
                                                        <StatusBadge>✓ Fechado</StatusBadge>
                                                    </strong>
                                                    <SeeDiaryButton onClick={() => seeDiary(rawBimester)}>
                                                        Ver Diário
                                                    </SeeDiaryButton>
                                                </>
                                            )
                                        }
                                    </StatusLine>
                                </DiaryBimester>
                                );
                            })}

                        {isFinalClosed && (
                            <FinalResultBlock>
                                <h3>Resultado Final</h3>
                                <button onClick={goToFinalResult}>
                                    ✔ Ver Resultado Final
                                </button>
                            </FinalResultBlock>
                        )}
                    </DiaryWrapper>

                    {showModal && (
                        <ContainerModal>
                            <ModalContent>
                                <h2>Fechar o diário?</h2>
                                <p>Verifique se todas as informações deste bimestre foram lançadas corretamente.</p>
                                <ModalWarnText>
                                    Após o fechamento, apenas o supervisor ou diretor poderá reabrir o bimestre.
                                </ModalWarnText>
                                <ModalActions>
                                    <ModalCancel onClick={() => setShowModal(false)}>Cancelar</ModalCancel>
                                    <ModalConfirm onClick={() => {
                                        handleClose(selectedBimester, selectedField);
                                        setShowModal(false);
                                    }}>
                                        Confirmar Fechamento
                                    </ModalConfirm>
                                </ModalActions>
                            </ModalContent>
                        </ContainerModal>
                    )}

                    <StudentSection>
                        <h2>🎓 Alunos</h2>
                        <StudentActions>
                            <LinkAction onClick={PrintableAttendanceSheet}>
                                🖨️ Imprimir lista de alunos
                            </LinkAction>
                            <LinkAction onClick={PrintableAllTheBulletinsGrades}>
                                📋 Emitir boletins da turma
                            </LinkAction>
                        </StudentActions>

                        <CountRow>
                            <CountChip>Total de alunos: <strong>{sortedStudents.length}</strong></CountChip>
                            {studentTransferMap.length > 0 && (
                                <CountChip>Transferidos: <strong>{studentTransferMap.length}</strong></CountChip>
                            )}
                        </CountRow>

                        {sortedStudents.length > 0 ? (
                            sortedStudents.map((stdt, i) => (
                                <StudentItem
                                    key={stdt._id}
                                    onClick={() => StudentInformation(stdt)}
                                    style={{ animationDelay: `${Math.min(i * 0.02, 0.4)}s` }}
                                >
                                    <span>{stdt.name}</span>
                                    {stdt.status === "inativo" && <StudentStatus $status="inativo">{stdt.status}</StudentStatus>}
                                    {stdt.status === "ativo" && <StudentStatus $status="ativo">{stdt.status}</StudentStatus>}
                                </StudentItem>
                            ))
                        ) : (
                            <InfoText>Carregando alunos...</InfoText>
                        )}

                        {studentTransferMap.length > 0 && (
                            <>
                                <TransferHeading>⚠️ Alunos transferidos e remanejados</TransferHeading>
                                {studentTransferMap.map(stdt => (
                                    <StudentItem key={stdt._id} onClick={() => StudentInformation(stdt)}>
                                        <span>{stdt.name}</span>
                                        {stdt.status === "ativo" && <StudentStatus $status="remanejado">Remanejado</StudentStatus>}
                                        {stdt.status === "inativo" && <StudentStatus $status="inativo">{stdt.status}</StudentStatus>}
                                        {stdt.status === "transferido" && <StudentStatus $status="transferido">{stdt.status}</StudentStatus>}
                                    </StudentItem>
                                ))}
                            </>
                        )}
                    </StudentSection>

                    <ToGoBack onClick={messageButtonClick}>
                        <SignMessageButtonText>← Voltar para a</SignMessageButtonText>
                        <SignMessageButtonTextBold>Lista de Turmas</SignMessageButtonTextBold>
                    </ToGoBack>

                    {AllBimBull && (
                        <ContainerModal>
                            <ModalContent>
                                {assessmentRegime === 'BIMESTRAL' && <h2>Selecione o Bimestre</h2>}
                                {assessmentRegime === 'TRIMESTRAL' && <h2>Selecione o Trimestre</h2>}
                                <Input>
                                    {assessmentRegime === 'BIMESTRAL' && <Label>Bimestres</Label>}
                                    {assessmentRegime === 'TRIMESTRAL' && <Label>Trimestre</Label>}
                                    <Select id="id-bimonthly" onChange={handleBimonthlyChange}>
                                        <option value="">
                                            {quartersLoaded ? 'Selecione' : 'Carregando...'}
                                        </option>
                                        {bimonthly
                                            .filter(res => {
                                                if (assessmentRegime === 'TRIMESTRAL') {
                                                    return res.bimonthly !== '4º BIMESTRE';
                                                }
                                                return true;
                                            })
                                            .map(res => (
                                                <option key={res._id} value={JSON.stringify(res)}>
                                                    {assessmentRegime === 'TRIMESTRAL'
                                                        ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                                        : res.bimonthly}
                                                </option>
                                            ))
                                        }
                                        <option value="FinalConcepts">Resultado Final</option>
                                    </Select>
                                    <ModalActions>
                                        <ModalCancel onClick={() => setBimAllBull(false)}>Cancelar</ModalCancel>
                                    </ModalActions>
                                </Input>
                            </ModalContent>
                        </ContainerModal>
                    )}

                    {showRegentWarning && (
                        <ModalBackground>
                            <ModalContainer>
                                <h2>Atenção!</h2>
                                <p>O lançamento das frequências é exclusivo do professor regente. No entanto, elas serão exibidas tanto no diário do professor de Educação Física quanto no diário do professor regente.</p>
                                <ModalButton onClick={() => setShowRegentWarning(false)}>Fechar</ModalButton>
                            </ModalContainer>
                        </ModalBackground>
                    )}
                </ContainerDivs>
            }
        </Container>
    )
}

export default MyCla$$Info